/* LO QUE ESTÁ VIAJANDO A LA BASE, CONTADO.
 *
 * Fabián e Igna, 09/10: CRT y MIC se recargan solos al entrar si hay versión
 * nueva «y no hay nada a medio cargar» (ver `AlDiaParaEmitir`). Recargar corta
 * todo pedido que esté en camino, y hay pantallas que siguen escribiendo
 * DESPUÉS de cerrarse: Mi espacio (FiboSheets) manda el libro entero al salir
 * —varios MB por una línea mala—, una foto o un PDF se siguen subiendo aunque
 * la persona ya haya cambiado de pantalla. Si la recarga llega antes que la
 * respuesta, eso no entra.
 *
 * Por eso el cliente de Supabase (uno solo, en SupabaseClient.js) pasa sus
 * pedidos por acá: los que escriben —todo lo que no es GET ni HEAD: insert,
 * update, upsert, delete, rpc, subidas al storage, funciones— se cuentan
 * mientras viajan. Un rpc de lectura también va por POST y también cuenta:
 * esperar a que termine cuesta un instante y no se pierde nada.
 *
 * Se descuenta cuando llega la respuesta (o falla): para entonces la base ya
 * la tomó. No cambia nada de los pedidos: mismos argumentos, misma respuesta,
 * mismo error. Sin `fetch` en el navegador no se envuelve nada (Supabase
 * tampoco tendría con qué pedir). */

let enCurso = 0;

export function escriturasEnCurso() {
  return enCurso;
}

const esEscritura = (entrada, opciones) => {
  const metodo = String(
    opciones?.method
      || (entrada && typeof entrada === "object" && entrada.method)
      || "GET",
  ).toUpperCase();
  return metodo !== "GET" && metodo !== "HEAD";
};

export function fetchQueCuenta(entrada, opciones) {
  if (!esEscritura(entrada, opciones)) return fetch(entrada, opciones);
  enCurso += 1;
  let pedido;
  try {
    pedido = fetch(entrada, opciones);
  } catch (e) {
    enCurso -= 1;
    throw e;
  }
  return Promise.resolve(pedido).finally(() => {
    enCurso -= 1;
  });
}

/* Para pasarle a `createClient`: el envoltorio, o nada si no hay `fetch`. */
export function fetchParaSupabase() {
  return typeof fetch === "function" ? fetchQueCuenta : undefined;
}
